<template>
    <div class="content3d--area relative" style="z-index:2; overflow:hidden;">
        <div class="b-container relative" style="padding-bottom:60px;">
            <div class="column v-center center mb-xxl">
                <div class="row">
                    <div class="h1 ml-xxl" style=" color: #ff3355;">专属礼品商城</div>
                    <div class="relative ml-md" style="width:84px; height:84px;">
                        <img :src="PlusRedIcon" style="width:84px; height:84px; position:absolute; top:-40px; left:-30px;" />
                    </div>
                </div>
             
	<!-- 			<div class="t4   summary" style="padding: 18px;">
				     {{title}}
				    </div> -->
					<div class="t4   summary" style="padding: 18px;">
					     {{title1}}
					    </div>
            </div>

            <!-- SWIPER START -->
            <div class="relative swiper-container-wrap" id="service-swiper-wrap222">
                <div v-show="paginationBulletsLength !== 1" class="swiper-prev column center v-start">
                    <img :src="IconPrev" style="display:block; width:19px; height:38px;" />
                </div>

                <div v-show="paginationBulletsLength !== 1" class="swiper-next column center v-end">
                    <img :src="IconNext" style="display:block; width:19px; height:38px;" />
                </div>

                <div class="swiper-container" id="service-swiper222">
                    <div class="swiper-wrapper">
                        <div v-for="(item, index) in software" class="swiper-slide service-swiper222-slide" :key="index">
                            <div class="card-item">
                                <div class="row mb-lg software-cover slideCard_image" >
                                        <img :src="item.cover" class="card-photo" style="width:100%;height: auto;"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="paginationBulletsLength !== 1" class="mt-xxl row v-center center" style="height:16px;">
                        <div class="swiper-pagination333"></div>
                    </div>
                </div>
            </div>
            <!-- SWIPER END -->
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';

import {
    IconPrev,
    IconNext,
    PlusWhiteIcon,
    PlusRedIcon,
    Arrow,
    NewService01,
    NewService02,
    NewService03,
	shanhai,
	gys,
	morecard,
	shop0,
	shop1,
		shop2,
			shop3,
				shop4,
				shop6,
				shop5,
				shop7
				 
} from '@/constants/pics';

export default {
    name: 'newservice',

    props: [],

    components: {},

    data() {
        return {
            swiper: null,

            IconPrev,
            IconNext,
            PlusWhiteIcon,
            PlusRedIcon,

            Arrow,

            currentItem: 0,
            activeIndex: -1,
			// title: '定制冠名专属商城，。宾客可参与互动，抢红包兑换礼品',
           title1: '千挑万选，不如让TA自选。商城汇聚上万款优质礼品、喜品、生活用品、特产等.',
			software: [
				{
						cover: shop0,
				},
				{
				cover: shop1,


				},
				{
				cover: shop2,


				},
				{
				cover: shop3,


				},
				{
				cover: shop4,


				},
				{
				cover: shop5,


				},
   //              {

			// cover: shop6,


			// 	},

				{
				cover: shop7,

				},
				

            ],
        };
    },

    computed: {
        paginationBulletsLength() {
            if (!this.swiper) {
                return 1;
            }

            return this.swiper.pagination.bullets.length;
        },
    },

    created() { },

    mounted() {
        this.$nextTick(function () {
            this.initSwiper();
        });

        let resizeTag = true;
        window.addEventListener('resize', () => {
            if (resizeTag) {
                resizeTag = false;
                setTimeout(() => {
                    resizeTag = true;
                    // this.$nextTick(function() {
                    //     this.initSwiper();
                    // });
                }, 300);
            }
        });
    },

    activated() { },

    deactivated() { },

    methods: {
        lightbox() {
            this.showLightbox = true;
        },

        close() {
            this.showLightbox = false;
        },

        initSwiper() {
            this.swiper = new Swiper('#service-swiper222', {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 0,
				loop: true,
				autoplay: {
					delay: 3000,
					disableOnInteraction: false,
				},
                slidesPerView: 'auto',
                threshold: 10,

                initialSlide: +this.currentItem,
                observer: true,
                observeParents: true,

                navigation: {
                    nextEl: '#service-swiper-wrap222 .swiper-next',
                    prevEl: '#service-swiper-wrap222 .swiper-prev',
                },

                pagination: {
                    el: '.swiper-pagination333',
                    clickable: true,
                },

                breakpoints: {
                    // when window width is >= 480px
                    0: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        // spaceBetween: 24,
                    },
                    479: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        // spaceBetween: 24,
                    },
                    480: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                        // spaceBetween: 24,
                    },
                    // when window width is >= 720px
                    719: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        // spaceBetween: 24,
                    },
                    720: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        // spaceBetween: 24,
                    },
                    // when window width is >= 1280px
                    1279: {
                       slidesPerView: 1,
                       slidesPerGroup: 1,
                        // spaceBetween: 24,
                    },
                    // when window width is >= 1280px
                    1280: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        // spaceBetween: 24,
                    },
                    // when window width is >= 1280px
                    1392: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                        // spaceBetween: 24,
                    },
                    // when window width is >= 1280px
                    5120: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                        // spaceBetween: 24,
                    },
                },
            });

            if (this.swiper) {
                this.swiper.on(
                    'slideChange',
                    () => {
                        this.currentItem = this.swiper.activeIndex;
                    },
                );
            }
        },
    },
};
</script>

<style scoped lang="scss">
@import '~@/stylesheets/modules/all';

.content3d--area {
    // background: linear-gradient(to right, rgba(255, 51, 85, 1) 0%, rgba(241, 53, 54, 1) 100%);
    // overflow: hidden;
	top: 25px;
}

// swiper-item
.swiper-container {
    width: 80%;
    height: auto;
}

.swiper-slide {
    // width: 320px;
    // height: 380px;
    // text-align: center;
    font-size: 18px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    position: relative;
}

.swiper-slide:after {
    content: '';
    position: relative;
    // margin-top: 133.33%;
}

.swiper-next,
.swiper-prev {
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 10;
    cursor: pointer;
    color: #333;
    width: 36px;
    height: auto;
    border-radius: 12px;
    border-radius: 0;
    will-change: transform;
    transition: all 300ms;
    outline: none;
}

.swiper-next:hover,
.swiper-prev:hover {
    width: 64px;
}

.swiper-next {
    right: -64px;
    left: auto;
    border-radius: 0;
    border-right: 0;
}

.swiper-prev {
    left: -64px;
    right: auto;
    border-radius: 0;
    border-left: 0;
}

//
//
//
a.more {
    color: #666;
    text-decoration: none;
}

// content3d-cover
.content3d-cover {
    background: rgba(127, 127, 127, 0.1);
    overflow: hidden;
}

.content3d-cover:after {
    content: '';
    position: relative;
    margin-top: 100%;
}

.content3d-cover a {
    display: block;
    width: 240px;
    height: 380px;
}

@media (max-width: 991px) {
    .content3d-title {
        padding: 0 15px;
    }

    .h1 {
        font-size: 24px;
    }

    .scroll-wrap {
        width: 100%;
        height: auto;
        overflow-x: auto;
        overflow-y: hidden;
    }

    .scroll-wrap .b-row {
        width: 900px;
    }

    .b-container {
        padding-left: 0;
        padding-right: 0;
    }

    .b-row {
        margin-left: 0;
        margin-right: 0;
    }

    // .company-item-wrap {
    //     flex: 0 0 320px;
    // }
    //
    // .company-item {
    //     width: 240px;
    //     height: 380px;
    // }

    a.more {
        font-size: 16px;
    }

    // .title {
    //     font-size: 16px;
    // }

    // .summary {
    //     font-size: 16px;
    // }
}

.swiper-item {
    overflow: hidden;
	height: auto;

}

.swiper-item .desc {
    will-change: transform;
    transition: all 300ms;
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 80px;
    z-index: 3;
    background: rgba(255, 255, 255, 0.88);
    text-align: left;
}

.swiper-item.hover .desc {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 196px;
    z-index: 3;
    color: #fff;
    // background: linear-gradient(to bottom, rgba(255, 51, 85, 0.8) 0%, rgba(241, 53, 54, 0.9) 100%);
    background: rgba(0, 0, 0, 0.5);
}

.swiper-button-disabled img {
    opacity: 0.38;
}

.lightbox {
    display: none;
}

.lightbox.display {
    display: block;
}

.swiper-container-wrap {
    margin-left: -15px;
    margin-right: -15px;
}

@media (max-width: 991px) {
    .swiper-container-wrap {
        margin-left: 0;
        margin-right: 0;
    }
}

//
.swiper-pagination .swiper-pagination-bullet-active {
    background: #ffffff !important;
}

//
//
//
a.more {
    color: #666;
    text-decoration: none;
}

.software-list a {
    text-decoration: none;
    color: #555;
}

.software-cover {
 //background: rgba(127, 127, 127, 0.1);
	 	background: blueviolet;
		width: 100%;
		height: auto;
    // overflow: hidden;
}

.software-cover:after {
    content: '';
    position: relative;
    margin-top: 62.5%;
}

.software-cover a {
    display: block;
    width: 100%;
    height: auto;
}

// slideCard_image
.card-item a:hover .slideCard_image:before {

    -webkit-transform: scaleX(1);
    -ms-transform: scaleX(1);
    transform: scaleX(1);
    -webkit-transform-origin: left;
    -ms-transform-origin: left;
    transform-origin: left;
    -webkit-transition: -webkit-transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
    transition: -webkit-transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
    transition: transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
    transition: transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1),
        -webkit-transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
	  height: auto;
}

.slideCard_image {

	height: auto;
    -webkit-transition-property: opacity;
    transition-property: opacity;
    -webkit-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    opacity: 1;

    position: relative;
    overflow: hidden;
}

.slideCard_image:before {
    content: '';
    position: absolute;
    top: 0;
    width: 100%;
    height: auto;
    z-index: 2;
    display: block;
    // background: linear-gradient(to right, rgba(255, 51, 85, 0.38) 0%, rgba(241, 53, 54, 0.2) 100%);
    // background: linear-gradient(to right, rgba(0, 0, 0, 0.38) 0%, rgba(0, 0, 0, 0.2) 100%);
    opacity: 1;
    -webkit-transform-origin: right;
    -ms-transform-origin: right;
    transform-origin: right;
    -webkit-transform: scaleX(0);
    -ms-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transition: -webkit-transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
    transition: -webkit-transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
    transition: transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
    transition: transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1),
        -webkit-transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
}

.card-item {
    padding: 0 15px;
}

.card-item a {
    text-decoration: none;
}

.card-item a .title {
    color: #000;
}

.card-item a .summary {
    color: #666;
}
</style>
